import { atom, useAtom } from "jotai";
import useTenant from "src/hooks/api/services/tenants/useTenant";

type Interval = "MONTHLY" | "YEARLY";

const planIntervalAtom = atom<Interval>("MONTHLY");

export default function usePlans() {
	const { tenant } = useTenant();
	const [interval, setInterval] = useAtom<Interval, any, any>(
		planIntervalAtom
	);
	return {
		interval,
		intervalEnabled: tenant.slug === "getjobsdone",
		actions: {
			setInterval,
		},
	};
}
